import { NgClass } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from "@angular/router";

@Component({
  selector: 'internal-sidebar',
  imports: [RouterLink, RouterLinkActive, NgClass],
  templateUrl: './internal-sidebar.component.html',
  styleUrl: './internal-sidebar.component.scss',
})
export class SidebarComponent {
  // injectables
  router = inject(Router);

  links = input<SidebarLink[]>();
  role = input.required<string>();

  expand_items: string[] = [];
  toggleGroup(name: string) {
    if (!this.expand_items.includes(name)) {
      this.expand_items.push(name);
      return;
    }
    if (this.expand_items.includes(name)) {
      this.expand_items.splice(this.expand_items.indexOf(name), 1);
      return;
    }
  }
    isExpanded(link: SidebarLink): boolean {
      return this.expand_items.includes(link.name) || this.hasActiveChild(link);
    }
  removeToggles() {
    this.expand_items = [];
  }
  hasActiveChild(link: SidebarLink): boolean {
    if (!link.children) return false;

    return link.children.some((child) =>
      this.router.isActive(child.url, {
        paths: 'exact',
        queryParams: 'ignored',
        fragment: 'ignored',
        matrixParams: 'ignored',
      }),
    );
  }
}

export interface SidebarLink{
  name: string,
  icon?: string,
  url: string,
  children?: SidebarLink[]
}
